enum CheckboxVariant {
  DEFAULT = 'default',
  LONG_TEXT = 'variant-long-text',
}

export { CheckboxVariant };
